import AccountingService from '@/api/AccountingService'

// initial state
const state = {
  debits: null,
  chartOfAccounts: [], // tree view
  chartOfAccountsList: [],
  journalEntries: [],
  journalEntry: null,
  nextJvCode: null,
}

// getters
const getters = {
  getDebits: state => state.debits,
  chartOfAccounts: state => state.chartOfAccounts,
  chartOfAccountsList: state => state.chartOfAccountsList,
  journalEntry: state => state.journalEntry,
  journalEntries: state => state.journalEntries,
  nextJvCode: state => state.nextJvCode,
}

// mutations
const mutations = {
  setDebits (state, data) {
    state.debits = data
  },
  setChartOfAccounts (state, data) {
    state.chartOfAccounts = data
  },
  setChartOfAccountsList(state, data) {
    state.chartOfAccountsList = data
  },
  setJournalEntries(state, data) {
    state.journalEntries = data
  },
  setJournalEntry(state, data) {
    state.journalEntry = data
  },
  setNextJvCode(state, data) {
    state.nextJvCode = data
  },
}

// actions
const actions = {
  async getDebits ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getDebits') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getDebits')

      let response = await AccountingService.getDebits()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getDebits')

      result = response.data

      if (result.success) {
        commit('setDebits', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getChartOfAccounts ({ commit }, { params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getChartOfAccounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getChartOfAccounts')

      let response = await AccountingService.getChartOfAccounts(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getChartOfAccounts')

      result = response.data

      if (result.success) {
        commit('setChartOfAccounts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getAccountsListChartOfAccounts ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getAccountsListChartOfAccounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getAccountsListChartOfAccounts')

      let response = await AccountingService.getAccountsListChartOfAccounts()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getAccountsListChartOfAccounts')

      result = response.data

      if (result.success) {
        commit('setChartOfAccountsList', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async insertChartOfAccounts ({ commit }, { data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('insertChartOfAccounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'insertChartOfAccounts')

      let response = await AccountingService.insertChartOfAccounts(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'insertChartOfAccounts')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updateChartOfAccounts ({ commit }, { accountId, data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateChartOfAccounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateChartOfAccounts')

      let response = await AccountingService.updateChartOfAccounts(accountId, data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateChartOfAccounts')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async deleteChartOfAccounts ({ commit }, { accountId }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('deleteChartOfAccounts') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'deleteChartOfAccounts')

      let response = await AccountingService.deleteChartOfAccounts(accountId)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'deleteChartOfAccounts')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getNextCodeJournalEntries ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextCodeJournalEntries') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextCodeJournalEntries')

      let response = await AccountingService.getNextCodeJournalEntries()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextCodeJournalEntries')

      result = response.data

      if (result.success) {
        commit('setNextJvCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  async getListJournalEntries ({ commit }, { params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getListJournalEntries') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getListJournalEntries')

      let response = await AccountingService.getListJournalEntries(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getListJournalEntries')

      result = response.data

      if (result.success) {
        commit('setJournalEntries', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getSingleJournalEntries ({ commit }, { jvId }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getSingleJournalEntries') >= 0) return

    try {
      commit('setJournalEntry', null)

      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getSingleJournalEntries')

      let response = await AccountingService.getSingleJournalEntries(jvId)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getSingleJournalEntries')

      result = response.data

      if (result.success && result.data.length) {
        commit('setJournalEntry', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async insertJournalEntries ({ commit }, { data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('insertJournalEntries') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'insertJournalEntries')

      let response = await AccountingService.insertJournalEntries(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'insertJournalEntries')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updateJournalEntries ({ commit }, { jvId, data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateJournalEntries') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateJournalEntries')

      let response = await AccountingService.updateJournalEntries(jvId, data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateJournalEntries')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updateStatusJournalEntries ({ commit }, { jvId, data }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateStatusJournalEntries') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateStatusJournalEntries')

      let response = await AccountingService.updateStatusJournalEntries(jvId, data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateStatusJournalEntries')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async deleteJournalEntries ({ commit }, { jvId }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('deleteJournalEntries') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'deleteJournalEntries')

      let response = await AccountingService.deleteJournalEntries(jvId)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'deleteJournalEntries')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updateJournalSetDefault ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateJournalSetDefault') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateJournalSetDefault')

      let response = await AccountingService.updateJournalSetDefault(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateJournalSetDefault')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updateJournalAutomatedAccountsMapping ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateJournalAutomatedAccountsMapping') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateJournalAutomatedAccountsMapping')

      let response = await AccountingService.updateJournalAutomatedAccountsMapping(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateJournalAutomatedAccountsMapping')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Accounting.js